import { EyeIcon } from "components/Icons";

const FileCell = () => {
  return (
    <span className="flex items-center justify-center group cursor-pointer rounded-md overflow-hidden ">
      <EyeIcon className="w-6 p-0.5 px-1 group-hover:text-black group-hover:opacity-50 fill-current" />
    </span>
  );
};

export default FileCell;
